// Utils
import { isObject } from 'ezyvet-fe-helpers';
// eslint-disable-next-line import/no-cycle
import { resolveNestedObjectsToObjectIdsForArray } from './resolveNestedObjectsToObjectIdsForArray';
import { getObjectId } from '../../objectIdentity';
/**
 * Encodes any contained objects of the given value
 *
 * @param {any} value
 *
 * @return {any}
 */
export var resolveObjectOrNestedObjectsToObjectIds = function (value) {
    if (Array.isArray(value)) {
        return resolveNestedObjectsToObjectIdsForArray(value);
    }
    if (isObject(value)) {
        return getObjectId(value);
    }
    return value;
};
//# sourceMappingURL=resolveObjectOrNestedObjectsToObjectIds.js.map